import React from 'react'
import { Modal } from 'rsuite'
import { Button } from '../../atoms/button/button'
import { ReactComponent as Close } from '../../../assets/svgs/modal-close.svg'
import './modal.scss'

interface ICustomModal {
  title: string
  size?: string
  body: React.ReactElement
  isOpen: boolean
  continueTitle: string
  abortTitle?: string
  isFormIncomplete: boolean
  isSetModalOpen: (val: boolean) => void
  handleSubmit: () => void
  isLoading?: boolean
  isAbortCTARequired?: boolean
  customModalWrapperName?: string
}
export const CustomModal = ({
  title,
  size = 'xs',
  body,
  isOpen,
  continueTitle,
  abortTitle,
  isFormIncomplete = true,
  isSetModalOpen,
  handleSubmit,
  isLoading,
  isAbortCTARequired = true,
  customModalWrapperName = '',
}: ICustomModal) => {
  const handleClose = () => isSetModalOpen(false)
  return (
    <Modal
      backdrop={true}
      keyboard={false}
      open={isOpen}
      onClose={handleClose}
      size={size}
      dialogClassName={`custom-modal-wrapper ${customModalWrapperName}`}
    >
      <div className="custom-modal-header">
        <p className="nav-head">{title}</p>
        <Button ButtonIcon={<Close />} handleClick={handleClose} />
      </div>
      <Modal.Body className="custom-modal-body">{body}</Modal.Body>

      <Modal.Footer className={`custom-modal-footer ${isAbortCTARequired ? 'full-bleed' : ''}`}>
        {isAbortCTARequired && (
          <Button handleClick={handleClose} label={abortTitle} variant={'secondary'} />
        )}
        <Button
          handleClick={handleSubmit}
          label={continueTitle}
          disabled={isFormIncomplete || isLoading}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default CustomModal
